// COLUMN LINK HACK

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".wp-block-column.tw-stretched-link")
    .forEach(function (col) {
      var h3link = col.querySelector("h3 a");
      var h2link = col.querySelector("h2 a");
      // Use the first heading link that exists (h2 or h3)
      var headingLink = h2link || h3link;

      // If no heading link is found, return
      if (!headingLink) return;

      // Spalte als relativen Container markieren
      if (getComputedStyle(col).position === "static") {
        col.style.position = "relative";
      }

      // Overlay-Link nur einmal erstellen
      if (col.querySelector(".column-overlay-link")) return;

      var overlay = document.createElement("a");
      overlay.className = "column-overlay-link";
      overlay.setAttribute("aria-hidden", "true");
      overlay.href = headingLink.href;

      // falls das Ziel oder rel wichtig sind, kopiere sie
      if (headingLink.target) overlay.target = headingLink.target;
      if (headingLink.rel) overlay.rel = headingLink.rel;

      col.insertBefore(overlay, col.firstChild);
    });
});

// ANIMATE FRONT PAGE TYPE HEADING
document.addEventListener("DOMContentLoaded", () => {
  const textContainer = document.getElementById("typewriter");

  // Only run if the element exists
  if (textContainer) {
    const words = [
      { text: "Leben", color: "#F59A00" },
      { text: "Wohnen", color: "#6DB037" },
      { text: "Bauen", color: "#17B4DE" },
      { text: "Sanieren", color: "#a3318b" },
    ];
    let currentWordIndex = 0;

    function animateWord(index) {
      const word = words[index].text.toUpperCase();
      const color = words[index].color;

      // Split word into letters and wrap in spans with 3D effect
      const chars = word
        .split("")
        .map(
          (char) =>
            `<span class="letter" style="color: ${color}; text-shadow: 3px 3px 5px rgba(0,0,0,0.6), 6px 6px 10px rgba(0,0,0,0.4); transform-style: preserve-3d; font-weight: bold;">${char}</span>`
        )
        .join("");
      textContainer.innerHTML = chars;

      // Anime.js animation timeline for the current word
      const tl = anime.timeline({
        complete: function () {
          currentWordIndex = (currentWordIndex + 1) % words.length;
          animateWord(currentWordIndex);
        },
      });

      tl.add({
        targets: ".letter",
        opacity: [0, 1],
        scale: [0, 1],
        rotateX: [-90, 0],
        rotateY: [-90, 0],
        easing: "easeOutElastic(1, 0.6)",
        duration: 800,
        delay: anime.stagger(100, { from: "center" }),
      }).add({
        targets: ".letter",
        opacity: [1, 0],
        scale: [1, 0.3],
        rotateX: [0, 90],
        rotateY: [0, 90],
        easing: "easeInExpo",
        duration: 400,
        delay: anime.stagger(80, { start: 1000 }),
      });
    }

    // Start the animation with the first word
    animateWord(currentWordIndex);
  }
});

// DETAILS BLOCK ACCORDION
